function buocQuanLyChuVuonVuon() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Chủ vườn & vườn",
      content:
        "Trang quản lý tập trung, dùng chung form với lúc nhân viên thu mua tạo mới ngoài hiện trường — cộng thêm xuất Excel và in QR mã chủ vườn (không có ở form hiện trường).",
    },
    {
      target: "#tour-quan-ly-chu-vuon-vuon-tabs",
      title: "Bước 2 · Hai danh sách trong 1 trang",
      content:
        'Tab "Chủ vườn" quản lý hồ sơ người trồng, tab "Vườn" quản lý từng vườn gắn với một chủ vườn cụ thể — cần có chủ vườn trước mới thêm được vườn.',
      placement: "bottom",
    },
    {
      target: "#tour-quan-ly-chu-vuon-vuon-nut-them",
      title: "Bước 3 · Thêm mới",
      content:
        "Bấm để mở form thêm chủ vườn (hoặc vườn, tuỳ tab đang mở) — mã QR định danh sẽ được hệ thống tự sinh. Khi thêm Vườn từ đây, cần chọn Chủ sở hữu có sẵn từ danh sách — khác với luồng hiện trường, nơi chủ vườn đã được chọn sẵn từ bước trước.",
      placement: "bottom",
    },
    {
      target: "#tour-quan-ly-chu-vuon-vuon-xuat-excel",
      title: "Bước 4 · Chọn nhiều để in QR hàng loạt",
      content:
        "Tick vào ô chọn ở đầu mỗi dòng chủ vườn trong bảng bên dưới để chọn nhiều — một thanh công cụ tải/in QR hàng loạt sẽ hiện ngay phía trên bảng. (Nút cạnh đây chỉ để xuất Excel danh sách.)",
      placement: "bottom",
    },
    {
      target: "#tour-quan-ly-chu-vuon-vuon-tim",
      title: "Bước 5 · Tìm nhanh chủ vườn",
      content:
        "Lọc theo Tên, CCCD hoặc SĐT — lọc ngay trên dữ liệu đã tải (không gọi lại server). Bộ lọc này chỉ áp dụng cho tab đang mở, và danh sách kết quả đang lọc cũng là danh sách được xuất khi bấm Xuất Excel.",
      placement: "bottom",
    },
  ];
}

export default buocQuanLyChuVuonVuon;
